export const SET_SELECTED_DASHBOARD = 'SET_SELECTED_DASHBOARD';
export const GET_DASHBOARD_DETAIL = 'GET_DASHBOARD_DETAIL';
export const SET_DASHBOARD_DETAIL = 'SET_DASHBOARD_DETAIL';
export const INSERT_DASHBOARD = 'INSERT_DASHBOARD';
export const UPDATE_DASHBOARD = 'UPDATE_DASHBOARD';
export const DELETE_DASHBOARD = 'DELETE_DASHBOARD';
export const SET_STATUS_CARD = 'SET_STATUS_CARD';
export const SET_ERROR_CARD = 'SET_ERROR_CARD';
export const SET_DASHBOARD_UNIT = 'SET_DASHBOARD_UNIT';
